import { Mail } from 'lucide-react';

interface GuestEmailSectionProps {
  email?: string;
  onEmailChange: (email: string) => void;
}

export function GuestEmailSection({ email, onEmailChange }: GuestEmailSectionProps) {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
      <h2 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
        <Mail className="w-5 h-5" aria-hidden="true" />
        Contact Information
      </h2>
      <div>
        <label htmlFor="guest-email" className="block text-sm font-medium text-gray-700 mb-2">
          Email Address *
        </label>
        <input
          type="email"
          id="guest-email"
          value={email || ''}
          onChange={(e) => onEmailChange(e.target.value)}
          placeholder="your.email@example.com"
          required
          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
          aria-required="true"
          aria-describedby="guest-email-description"
        />
        <p id="guest-email-description" className="mt-2 text-sm text-gray-500">
          We'll send your order confirmation to this email address.
        </p>
      </div>
    </div>
  );
}
